// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".space-section[data-v-b52e565e] {\n  margin-top: 1.5rem;\n}\n.question-list[data-v-b52e565e] {\n  gap: 1rem;\n  display: grid;\n}\n.empty-state[data-v-b52e565e] {\n  padding: 1rem;\n  text-align: center;\n  color: #76838f;\n  background: #f8fafc;\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
